module.exports = __webpack_public_path__ + "img/646.00966e0d.jpg";